import type { SVGProps } from "react";
export interface NoseIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function NoseIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: NoseIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M18.266 16.374a1.126 1.126 0 0 1 0 2.25c-.594 0-1.146.282-1.497.748.672.49 1.541.633 2.337.367l.194-.073a2.59 2.59 0 0 0 1.575-2.382c0-1.454-.72-2.324-1.883-3.819a11.1 11.1 0 0 1-2.078-4.416l-1.512-6.804a1.126 1.126 0 0 1 2.196-.49l1.513 6.806.12.477a8.9 8.9 0 0 0 1.538 3.046l.812 1.05c.81 1.099 1.543 2.378 1.544 4.15a4.84 4.84 0 0 1-2.945 4.452l-.363.137a4.83 4.83 0 0 1-4.198-.558 4.523 4.523 0 0 1-7.238 0 4.84 4.84 0 0 1-3.898.648l-.3-.09a4.84 4.84 0 0 1-3.308-4.589c0-2.356 1.297-3.837 2.357-5.2l.29-.397A8.9 8.9 0 0 0 4.89 8.56l1.512-6.806.03-.11a1.125 1.125 0 0 1 2.166.6L7.086 9.049a11.1 11.1 0 0 1-2.079 4.416c-1.17 1.505-1.882 2.37-1.882 3.82 0 1.113.713 2.102 1.77 2.454l.322.085a2.58 2.58 0 0 0 2.014-.453 1.87 1.87 0 0 0-1.244-.729l-.252-.018-.115-.005a1.125 1.125 0 0 1 .115-2.245l.279.01a4.12 4.12 0 0 1 3.326 2.113l.331.593.342.616a2.274 2.274 0 0 0 3.975 0l.671-1.209a4.13 4.13 0 0 1 3.607-2.123"
      />
    </svg>
  );
}
